import {ConfigurationContext} from "../configuration/configuration";
import React, {useContext} from "react";
import {TooltipLink} from "./buttons/nav-buttons";
import {ChevronRightIcon, FlagDE, FlagES, FlagGB, fs_small} from "./icons/nav-icons";

export const localeFlags = {
    'de': <FlagDE className="font-1_75x"/>,
    'es': <FlagES className="font-1_75x"/>,
    'en-GB': <FlagGB className="font-1_75x"/>,
}

// helper for language navigation dropdown actions
const NavigationLanguageDropdown = () => {
    const {Lang, setLocale} = useContext(ConfigurationContext);

    const changeLocale = (event, locale) => {
        event.preventDefault();
        setLocale(locale);
    }
    return <div className="dropdown-menu navbar-actions-dropdown">
        <TooltipLink className='dropdown-item' to='#'
                     onClick={(e) => changeLocale(e, 'de')}>
            <div className="d-flex align-items-center">
                <ChevronRightIcon size={fs_small} className='ml--2'/>
                <span>{Lang.languages.de}</span></div>
        </TooltipLink>
        <TooltipLink className='dropdown-item' to='#'
                     onClick={(e) => changeLocale(e, 'es')}>
            <div className="d-flex align-items-center">
            <ChevronRightIcon size={fs_small} className='ml--2'/>
                <span>{Lang.languages.es}</span></div>
        </TooltipLink>
        <TooltipLink className='dropdown-item' to='#'
                     onClick={(e) => changeLocale(e,'en-GB')}>
            <div className="d-flex align-items-center">
            <ChevronRightIcon size={fs_small} className='ml--2'/>
                <span>{Lang.languages.en}</span></div>
        </TooltipLink>
    </div>
}

export default NavigationLanguageDropdown;